export const menuItems = [
    {
        id: 1,
        label: "menuitems.menu.text",
        isTitle: true
    },
    {
        id: 2,
        label: "menuitems.dashboard.text",
        icon: "bx-home-alt",
        link: "/ct-admin",
    },
    {
        id: 3,
        label: "Tenants",
        icon: "bxs-group",
        link: "/ct-admin/tenants",
    },
    {
        id: 4,
        label: "Api Consumer",
        icon: "bxs-group",
        link: "/ct-admin/api-consumer",
    }
];

